import { APP_ROUTES } from 'shared/constants/navigation';
import { COMPLETE_STEP } from 'vendor/constants/WebstoreSetupSteps';

const RequireWebstoreComplete = (context) => {
    const { CurrentSetupStep } = context.store.webstore;

    if (CurrentSetupStep === COMPLETE_STEP) return 'next';

    if (context.store.appData.featureToggles.newVendor) {
        return APP_ROUTES.vendor.webstore.newsetup;
    }

    return APP_ROUTES.vendor.webstore.setup;
};

export default RequireWebstoreComplete;
